var _defs, _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBanknote(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 141.73 141.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{opacity:0.39;fill:url(#linear-gradient-2);}.cls-3{fill:url(#linear-gradient-3);}.cls-4{fill:url(#linear-gradient-4);}.cls-5{fill:url(#linear-gradient-5);}.cls-6{fill:url(#linear-gradient-6);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 14.18,
    y1: 72.19,
    x2: 127.05,
    y2: 72.19,
    gradientTransform: "translate(-16.34 20.08) rotate(-15.21)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a0ddea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6bcbd2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 15.09,
    y1: 90.64,
    x2: 130.7,
    y2: 90.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#47bdc6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00737c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 108.8,
    y1: 59.1,
    x2: 130.85,
    y2: 59.1,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 38.92,
    y1: 75.43,
    x2: 66.91,
    y2: 71.17,
    gradientTransform: "translate(-10.12 2.73) rotate(-6.86)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 24.03,
    y1: 100.13,
    x2: 39.28,
    y2: 97.81,
    gradientTransform: "translate(17.81 -5.27) rotate(9.56)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 73.03,
    y1: 62.53,
    x2: 114.07,
    y2: 56.27,
    xlinkHref: "#linear-gradient-2"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard 4 copy 13") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21,103.21a4.25,4.25,0,0,0,3.38,3.06,64.32,64.32,0,0,0,22.52,0C63.16,103.3,70.78,95,83.44,89c9.21-4.41,23-8.52,42.83-7a4.24,4.24,0,0,0,4.43-5.33l-10-36.71a4.28,4.28,0,0,0-3.67-3.11c-21.56-2.2-36.28,2.11-46,6.75C58.43,49.59,50.81,57.88,34.51,60.85a63.57,63.57,0,0,1-18.86.54A4.23,4.23,0,0,0,11,66.69Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M130.7,76.61h0c-24.32-8.93-47.92,6.77-72.82,20.94-14.45,8.23-38.45,0-42.79-16L21,103.21a4.25,4.25,0,0,0,3.38,3.06,64.33,64.33,0,0,0,22.52,0C63.16,103.3,70.78,95,83.44,89c9.21-4.41,23-8.52,42.83-7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M120.72,39.9a4.28,4.28,0,0,0-3.67-3.11c-2.87-.29-5.62-.46-8.25-.54l13,45.45c1.48,0,3,.12,4.52.24a4.24,4.24,0,0,0,4.43-5.33Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M42.65,79.71,42.08,78l3-6.15q.44-.91.69-1.59A4.81,4.81,0,0,0,46.06,69a2.61,2.61,0,0,0-.13-1.14,2.11,2.11,0,0,0-.64-1,2,2,0,0,0-1-.42,2.56,2.56,0,0,0-1.2.17,2.43,2.43,0,0,0-1,.69,2.05,2.05,0,0,0-.49,1,2.63,2.63,0,0,0,.13,1.28l-2.21.82A4.47,4.47,0,0,1,39.33,68a4.22,4.22,0,0,1,1.05-2,5.46,5.46,0,0,1,2.09-1.38,5.24,5.24,0,0,1,2.47-.36,3.82,3.82,0,0,1,2,.81,3.77,3.77,0,0,1,1.22,1.81,4.28,4.28,0,0,1,.21,1.6,7.06,7.06,0,0,1-.46,2,29.12,29.12,0,0,1-1.27,2.87l-1.48,3.15,0,.09,5.74-2,.68,2ZM58.26,74.6a5,5,0,0,1-3.1.14,5.47,5.47,0,0,1-2.59-1.8,10.75,10.75,0,0,1-1.87-3.58,10.93,10.93,0,0,1-.63-4,5.79,5.79,0,0,1,1-3.06,5.25,5.25,0,0,1,2.51-1.88,4.94,4.94,0,0,1,3.1-.24,5.24,5.24,0,0,1,2.64,1.75,10.53,10.53,0,0,1,1.93,3.63,11.3,11.3,0,0,1,.64,4.13,5.73,5.73,0,0,1-1,3.1A5.14,5.14,0,0,1,58.26,74.6Zm-.7-2.1a2.48,2.48,0,0,0,1.62-2,8,8,0,0,0-.49-4,9.56,9.56,0,0,0-1.26-2.64,3.67,3.67,0,0,0-1.53-1.33,2.19,2.19,0,0,0-1.65,0,2.52,2.52,0,0,0-1.58,2,8,8,0,0,0,.49,4,10,10,0,0,0,1.23,2.63,3.75,3.75,0,0,0,1.51,1.35A2.22,2.22,0,0,0,57.56,72.5Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M27.89,101.27l-.27-1c.7-.9,1.05-1.37,1.75-2.34.16-.24.3-.45.4-.64a1.62,1.62,0,0,0,.19-.56,1.25,1.25,0,0,0,0-.57,1.48,1.48,0,0,0-.33-.59,1.52,1.52,0,0,0-.52-.39,1.61,1.61,0,0,0-.64-.14.88.88,0,0,0-.56.13.64.64,0,0,0-.29.39,1.31,1.31,0,0,0,0,.64l-1.2-.09a2.13,2.13,0,0,1,0-1.17,1.29,1.29,0,0,1,.61-.73A2.3,2.3,0,0,1,28.14,94a3.25,3.25,0,0,1,1.32.27,3,3,0,0,1,1.05.74,2.53,2.53,0,0,1,.62,1.09,2.25,2.25,0,0,1,.09.81,2.79,2.79,0,0,1-.28.9A8.91,8.91,0,0,1,30.2,99l-.86,1.25a.09.09,0,0,0,0,.05c1.24.08,1.87.1,3.14.08l.33,1.15A36.5,36.5,0,0,1,27.89,101.27Zm8.54.23a2.84,2.84,0,0,1-1.67-.37,4,4,0,0,1-1.37-1.3,7,7,0,0,1-1-2.09,5.72,5.72,0,0,1-.28-2.08,2.15,2.15,0,0,1,.56-1.36,2.17,2.17,0,0,1,1.35-.6,2.87,2.87,0,0,1,1.62.24,3.54,3.54,0,0,1,1.37,1.16,6.64,6.64,0,0,1,1,2.05,6.44,6.44,0,0,1,.32,2.21,2.41,2.41,0,0,1-.56,1.5A2,2,0,0,1,36.43,101.5Zm-.36-1.18A1,1,0,0,0,37,99.5a4.35,4.35,0,0,0-.24-2.14,6.34,6.34,0,0,0-.64-1.49,2.58,2.58,0,0,0-.79-.84,1.26,1.26,0,0,0-.87-.21.94.94,0,0,0-.86.79,4.2,4.2,0,0,0,.21,2.06,6.93,6.93,0,0,0,.63,1.51,2.8,2.8,0,0,0,.79.89A1.3,1.3,0,0,0,36.07,100.32Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M109.25,58.38C110.77,66.87,102.82,74,95,75.31A15.79,15.79,0,0,1,77,63.14c-1.77-8.49,3.34-18.51,13.16-19.31A17.82,17.82,0,0,1,109.25,58.38Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanknote);
export default __webpack_public_path__ + "static/media/banknote.87bc24bb5e4c0bc770b5f5b0150d8408.svg";
export { ForwardRef as ReactComponent };